import { createStoreAction } from '@cobuildlab/react-simple-state';
import { deleteUserDialogStore, userChangeStatusDialogStore } from './user-stores';
import { DeleteUserDialogStore, UserChangeStatusDialogStore } from './user-types';


export const userChangeStatusDialogStoreAction = createStoreAction(userChangeStatusDialogStore, (prev, data: UserChangeStatusDialogStore) => ({
  ...prev,
  ...data,
}));


export const deleteUserDialogStoreAction = createStoreAction(deleteUserDialogStore, (prev, data: DeleteUserDialogStore) => ({
  ...prev,
  ...data,
}));


